import axios from 'axios';

// Create Axios instances for different services
const authApiClient = axios.create({
    baseURL: 'https://auth.inspirapix.com/api/auth',
    headers: {
        'Content-Type': 'application/json',
    },
});

const generalApiClient = axios.create({
    baseURL: 'https://service.inspirapix.com/api/', // Replace with your actual user API base URL
    headers: {
        'Content-Type': 'application/json',
    },
});


const publicApiClient = axios.create({
    baseURL: 'https://service.inspirapix.com/', // Replace with your actual user API base URL
    headers: {
        'Content-Type': 'application/json',
    },
});



// Add request interceptor to include auth token for authApiClient
authApiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('authToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add request interceptor to include auth token for userApiClient
generalApiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('authToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add response interceptors to handle unauthorized responses
const handleUnauthorized = (error) => {
  if (error.response?.status === 401) {
    // Clear auth data
    localStorage.removeItem('authToken');
    localStorage.removeItem('userProfile');
    localStorage.removeItem('userCredits');
    localStorage.removeItem('userId');
    // Redirect to sign in
    window.location.href = '/sign-in';
  }
  return Promise.reject(error);
};

authApiClient.interceptors.response.use(
  (response) => response,
  handleUnauthorized
);

generalApiClient.interceptors.response.use(
  (response) => response,
  handleUnauthorized
);

// API Calls for auth
export const forgotPassword = (data) => {
    return authApiClient.post('/forgot-password', data);
};

export const resetPassword = (data) => {
    return authApiClient.post('/reset-password', data);
};

export const signIn = (data) => {
    return authApiClient.post('/signin', data);
};

export const signUp = (data) => {
    return authApiClient.post('/register', data);
};

export const verifyOTP = (data) => {
    return authApiClient.post('/verify-email', data);
};

// This is for registration
export const resendOTP = (data) => {
    return authApiClient.post('/resend-otp', data);
};

// API Calls for user
export const changePassword = (data) => {
    return authApiClient.post('/change-password', data);
};


export const logout = () => {
    return authApiClient.post('/logout');
};





//--------------------------------User API--------------------------------
export const updateProfile = (data) => {
    return generalApiClient.put('/update-profile', data);
};

export const getProfile = () => {
    return generalApiClient.get('/get-profile');
};

export const generateImage = (data) => {
    return generalApiClient.post('/generate', data);
};

export const getArtGenFormats = () => {
    return generalApiClient.get('/general/art-gen-formats');
};

export const getPipelinesCost = () => {
    return generalApiClient.get('/general/pipelines-cost');
};

// Interaction APIs
export const likeImage = (publicId) => {
    return generalApiClient.post(`/interactions/like/${publicId}`);
};

export const addComment = (publicId, comment) => {
    return generalApiClient.post(`/interactions/comment/${publicId}`, { comment });
};

export const addReply = (publicId, commentId, reply) => {
    return generalApiClient.post(`/interactions/comment/${publicId}/${commentId}/reply`, { reply });
};

export const getComments = (publicId) => {
    return publicApiClient.get(`/interactions/comments/${publicId}`);
};

export const incrementView = (publicId) => {
    return publicApiClient.post(`/interactions/view/${publicId}`);
};

// Public APIs
export const search = ({ params }) => {
    return publicApiClient.get('/search', { params });
};

export const trending = ({ params }) => {
    return publicApiClient.get('/trending', { params });
};

export const selectedContent = (publicId) => {
    return publicApiClient.get(`/content/${publicId}`);
};
//--------------------------------User API--------------------------------

//--------------------------------Payment API--------------------------------
export const getSubscriptionStatus = () => {
    return generalApiClient.get('/payments/paypal/subscription-status');
};

export const createPayPalOrder = (packageDetails) => {
    return generalApiClient.post('/payments/paypal/create-order', { packageDetails });
};

export const capturePayPalPayment = (orderId) => {
    return generalApiClient.post('/payments/paypal/capture-payment', { orderId });
};

export const verifyPayPalPayment = (orderId) => {
    return generalApiClient.get(`/payments/paypal/verify-payment/${orderId}`);
};
//--------------------------------Payment API--------------------------------

// export default { authApiClient, generalApiClient, publicApiClient };